import { useTranslation, Modal, TextAlign, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { EditProfileConfirmationModalPropType } from './types/propTypes';
import styles from './EditProfileConfirmationModal.module.scss';

const EditProfileConfirmationModal = ({ onClose, onPrimaryButtonClick }: EditProfileConfirmationModalPropType) => {
  const t = useTranslation();

  return (
    <div data-testid="profile-edit-confirm-model-testid">
      <Modal
        headline={''}
        primaryButtonLabel={t('subscription.profileEditConfirmation.modal.continue.buttonText')}
        secondaryButtonLabel={t('subscription.subscriptionSelection.cancelButtonText')}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSecondaryButtonClick={onClose}
        onClose={onClose}
        textAlign={TextAlign.CENTER}
        useReactPortal={true}
        portalContainerId="react-portal-modal"
      >
        <div className={styles['profile-edit-confirm-modal']}>
          <div className={styles['profile-edit-confirm-modal-icon']}>
            <NextgenImage
              alt={t('subscription.profileEditConfirmation.model.title')}
              src="/images/Products.svg"
              data-testid="edit-profile-icon-testid"
              objectFit="contain"
              width={142}
              height={110}
              className={styles['edit-profile-image']}
              isRelativeURL={true}
              loaderType={LoaderType.WEBFONTS}
            />
          </div>
          <label className={styles['profile-edit-confirm-modal-title']}>
            {t('subscription.profileEditConfirmation.model.title')}
          </label>
          <div className={styles['profile-edit-confirm-modal-content']}>
            {t('subscription.profileEditConfirmation.modal.content')}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditProfileConfirmationModal;
